import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import reducers from "./reducers";
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import "bootstrap/dist/css/bootstrap.min.css";
import thunk from "redux-thunk";
const middlewares = [thunk];
const store = createStore(reducers, applyMiddleware(...middlewares));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
);
